import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { COUNTRIES } from "@/lib/shop";

const F = ({ id, label, children, className = "" }) => (
  <div className={`space-y-1.5 ${className}`}>
    <Label htmlFor={id} className="text-xs font-bold uppercase tracking-wider text-muted-foreground">{label}</Label>
    {children}
  </div>
);

export const AddressFields = ({ value, onChange, prefix = "address" }) => {
  const set = (k) => (e) => onChange({ ...value, [k]: e.target.value });
  const inp = (k, label, props = {}, className = "") => (
    <F id={`${prefix}-${k}`} label={label} className={className}>
      <Input id={`${prefix}-${k}`} data-testid={`${prefix}-${k}-input`} value={value[k] || ""} onChange={set(k)} className="h-11 bg-white" {...props} />
    </F>
  );
  return (
    <div className="grid grid-cols-2 gap-3">
      {inp("full_name", "Nome e cognome", { autoComplete: "name" }, "col-span-2")}
      {inp("phone", "Telefono", { type: "tel", autoComplete: "tel" }, "col-span-2 sm:col-span-1")}
      <F id={`${prefix}-country`} label="Paese" className="col-span-2 sm:col-span-1">
        <select
          id={`${prefix}-country`}
          data-testid={`${prefix}-country-select`}
          value={value.country || "IT"}
          onChange={set("country")}
          className="h-11 w-full rounded-md border border-input bg-white px-3 text-sm"
        >
          {COUNTRIES.map(([c, n]) => <option key={c} value={c}>{n}</option>)}
        </select>
      </F>
      {inp("address", "Indirizzo e numero civico", { autoComplete: "street-address" }, "col-span-2")}
      {inp("zip", "CAP", { autoComplete: "postal-code", inputMode: "numeric" })}
      {inp("province", "Provincia", { maxLength: 40 })}
      {inp("city", "Città", { autoComplete: "address-level2" }, "col-span-2")}
    </div>
  );
};

export const addressComplete = (a) =>
  ["full_name", "phone", "address", "city", "zip", "country"].every((k) => (a[k] || "").trim().length >= 2) &&
  (a.phone || "").trim().length >= 5;
